/**
 * VIEW INVOICE — سبد خرید و فاکتور
 */

import { formatPrice, escapeHtml, ImageCache } from '../utils.js';

export function render(cart, products, financials, orderNotes, callbacks) {
  const emptyState    = document.getElementById('cart-empty-state');
  const activeContent = document.getElementById('cart-active-content');
  const stickyBar     = document.getElementById('invoice-sticky-bar');

  if (cart.length === 0) {
    emptyState.classList.remove('hidden');
    activeContent.classList.add('hidden');
    stickyBar.classList.add('hidden');
    return;
  }

  emptyState.classList.add('hidden');
  activeContent.classList.remove('hidden');
  stickyBar.classList.remove('hidden');

  _renderItems(cart, products, callbacks);
  _renderTotals(financials);

  const notesTA = document.getElementById('order-notes');
  if (notesTA) notesTA.value = orderNotes || '';
}

function _renderItems(cart, products, callbacks) {
  const list = document.getElementById('invoice-items-list');
  list.innerHTML = '';
  cart.forEach(item => {
    const prod = products.find(p => p.id === item.productId);
    if (!prod) return;
    const addonsText = item.selectedAddons.length > 0 ? item.selectedAddons.join(' + ') : 'ساده';
    const cached     = ImageCache.get(prod.image);
    const imgSrc     = cached || prod.image || `https://placehold.co/150x150/ff5c35/ffffff?text=${encodeURIComponent(prod.name)}`;

    const row = document.createElement('div');
    row.className = 'cart-item-row';
    row.innerHTML = `
      <div class="cart-item-info">
        <div class="cart-item-thumbnail">
          <img src="${escapeHtml(imgSrc)}" alt="${escapeHtml(prod.name)}"
               onerror="this.src='https://placehold.co/150x150/ff5c35/ffffff?text=%D8%BA%D8%B0%D8%A7'">
        </div>
        <div class="cart-item-details">
          <span class="cart-item-title">${escapeHtml(prod.name)}</span>
          <span class="cart-item-addons"><i class="fa-solid fa-square-plus"></i> ${escapeHtml(addonsText)}</span>
        </div>
      </div>
      <div class="cart-item-actions">
        <span class="price-tag" style="font-size:.82rem;">${formatPrice(item.linePrice * item.quantity)}</span>
        <div class="quantity-control" style="transform:scale(.9);">
          <button class="btn-qty btn-item-minus"><i class="fa-solid fa-minus"></i></button>
          <span class="qty-val">${item.quantity}</span>
          <button class="btn-qty btn-item-plus"><i class="fa-solid fa-plus"></i></button>
        </div>
      </div>`;
    row.querySelector('.btn-item-plus').addEventListener('click',  () => callbacks.onItemAdd(item.productId, item.selectedAddons));
    row.querySelector('.btn-item-minus').addEventListener('click', () => callbacks.onItemRemove(item.productId, item.selectedAddons));
    list.appendChild(row);
  });
}

function _renderTotals(financials) {
  document.getElementById('summary-subtotal').textContent = formatPrice(financials.subtotal);

  const discountRow = document.getElementById('summary-discount-row');
  if (financials.discount > 0) {
    discountRow.classList.remove('hidden');
    document.getElementById('summary-discount').textContent = `-${formatPrice(financials.discount)}`;
  } else {
    discountRow.classList.add('hidden');
  }

  const deliveryEl = document.getElementById('summary-delivery');
  deliveryEl.textContent = financials.deliveryFee === 0 ? 'رایگان' : formatPrice(financials.deliveryFee);
  deliveryEl.classList.toggle('text-secondary', financials.deliveryFee === 0);

  document.getElementById('summary-grandtotal').textContent    = formatPrice(financials.grandTotal);
  document.getElementById('invoice-payable-total').textContent = formatPrice(financials.grandTotal);
}

export function setCouponMessage(text, isSuccess) {
  const el = document.getElementById('coupon-message');
  if (!el) return;
  el.className   = isSuccess ? 'text-secondary' : 'text-primary';
  el.textContent = text;
}
